import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Navbar from './Navbar';
import Footer from './Footer';
import ToastContainer from '../common/Toast';

export default function Layout() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen flex flex-col page-bg">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      {!isAuthenticated && <Footer />}
      <ToastContainer />
    </div>
  );
}
